import PropTypes from "prop-types";
import React, { Component } from "react";
import { Switch, Route, NavLink, useLocation } from "react-router-dom";
import {
  Button,
  Container,
  Icon,
  Image,
  Menu,
  Responsive,
  Segment,
  Sidebar,
} from "semantic-ui-react";

import routes, { flattenRoutes } from "../routes";
import { Navigation, Content, Footer } from "./layout";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const previousPathname = React.useRef(pathname);

  React.useEffect(() => {
    if (previousPathname.current !== pathname) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      previousPathname.current = pathname;
    }
  }, [pathname]);

  return null;
};

// <Responsive getWidth={getWidth} minWidth={Responsive.onlyTablet.minWidth}>
// </Responsive>

class DesktopContainer extends Component {
  render() {
    return (
      <>
        <Navigation items={routes.items} />
        <Switch>
          {flattenRoutes(routes.items).map((route) => (
            <Route
              exact
              path={route.path}
              render={(props) => <route.component {...props} />}
            />
          ))}
        </Switch>
        <Footer />
      </>
    );
  }
}

// Heads up!
// We using React Static to prerender our docs with server side rendering, this is a quite simple solution.
// For more advanced usage please check Responsive docs under the "Usage" section.
const getWidth = () => {
  const isSSR = typeof window === "undefined";

  return isSSR ? Responsive.onlyTablet.minWidth : window.innerWidth;
};

const HomepageHeading = ({ mobile }) => (
  <Container fluid>
    {/* <Header
      as="h1"
      content="Transition Centre-Sud"
      inverted
      style={{
        fontSize: mobile ? "2em" : "4em",
        fontWeight: "normal",
        marginBottom: 0,
        marginTop: mobile ? "1.5em" : "3em"
      }}
    />
    <Header
      as="h2"
      content="Do whatever you want when you want to."
      inverted
      style={{
        fontSize: mobile ? "1.5em" : "1.7em",
        fontWeight: "normal",
        marginTop: mobile ? "0.5em" : "1.5em"
      }}
    />
    <Button primary size="huge">
      Get Started
      <Icon name="right arrow" />
    </Button> */}
    {/* <ImageExampleFluid /> */}
  </Container>
);

HomepageHeading.propTypes = {
  mobile: PropTypes.bool,
};

class MobileContainer extends Component {
  state = {};

  handleSidebarHide = () => this.setState({ sidebarOpened: false });

  handleToggle = () => this.setState({ sidebarOpened: true });

  render() {
    const { children } = this.props;
    const { sidebarOpened } = this.state;

    return (
      <Responsive
        as={Sidebar.Pushable}
        getWidth={getWidth}
        maxWidth={Responsive.onlyMobile.maxWidth}
      >
        <Sidebar
          as={Menu}
          animation="push"
          inverted
          onHide={this.handleSidebarHide}
          vertical
          visible={sidebarOpened}
        >
          {/* <MainMenu items={Routes.items} /> */}
        </Sidebar>

        <Sidebar.Pusher dimmed={sidebarOpened}>
          <Segment
            inverted
            textAlign="center"
            style={{ minHeight: 350, padding: "1em 0em" }}
            vertical
          >
            <Container>
              <Menu inverted pointing secondary size="large">
                <Menu.Item onClick={this.handleToggle}>
                  <Icon name="sidebar" />
                </Menu.Item>
                <Menu.Item position="right">
                  <Button as="a" inverted>
                    Log in
                  </Button>
                  <Button as="a" inverted style={{ marginLeft: "0.5em" }}>
                    Sign Up
                  </Button>
                </Menu.Item>
              </Menu>
            </Container>
            <HomepageHeading mobile />
          </Segment>
          {children}
        </Sidebar.Pusher>
      </Responsive>
    );
  }
}

MobileContainer.propTypes = {
  children: PropTypes.node,
};

const App = ({ children }) => (
  <div>
    <ScrollToTop />
    <DesktopContainer>{children}</DesktopContainer>
    {/* <MobileContainer>{children}</MobileContainer> */}
  </div>
);

App.propTypes = {
  children: PropTypes.node,
};

export default App;
